var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-popover',{attrs:{"trigger":"hover"}},[_c('div',{staticClass:"list-body-cell-popover-container",style:(_vm.containerStyle),attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2),_c('span',{staticClass:"list-body-cell-popover-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }